import { PonderDataClient } from "@apiserver-rest/ponder-data-client";
import { UserStatsContainer } from "../user-stats-container.component";
import { take } from "rxjs";
import { LoadingComponent } from "@ponder-shared/loading/loading.component";
import { GetMagicCollectionCardsForStatsResponse, MagicCardForStats, MagicSetForStats } from "@apiserver-rest/ponder-data-client-base";
import { MagicCollectionAgeChartComponent } from "./magic-collection-age-chart.component";
import { MagicCollectionSetsComponent } from "./magic-collection-sets.component";
import { Component } from "@angular/core";

@Component({
    selector: "user-collection-magic-stats",
    imports: [
        LoadingComponent,
        MagicCollectionAgeChartComponent,
        MagicCollectionSetsComponent
    ],
    templateUrl: "./user-collection-magic-stats.component.html"
})
export class UserCollectionMagicStatsComponent extends UserStatsContainer {
    public isLoading: boolean = true;
    public loadingSuccess: boolean = false;
    public hasData: boolean = false;

    public magicCards?: MagicCardForStats[];
    public magicSets?: MagicSetForStats[];

    public constructor(ponderDataClient: PonderDataClient) {
        super(ponderDataClient);
    }

    public override onInitialize(): void {
        this.ponderDataClient
            .magicCollectionStats(this.username)
            .pipe(take(1))
            .subscribe({
                next: (response: GetMagicCollectionCardsForStatsResponse) => {
                    if (response.success) {
                        this.loadingSuccess = true;

                        this.magicCards = response.magicCards;
                        this.magicSets = response.magicSets;

                        if (this.magicCards?.length) {
                            this.hasData = true;
                        }
                    }
                }
            })
            .add(() => { this.isLoading = false; })
    }
}